// Mur de Preuves — messages type WhatsApp/avis (MOCK, contenu fictif on-brand)
// + captures d'écran réelles réutilisées depuis mock.js
import { SCREENSHOTS } from "../mock";

export const WALL_MESSAGES = [
  { name: "Émilie", text: "Depuis le module 3, je dors enfin sereinement. Merci Gilles", time: "09:42" },
  { name: "Karine", text: "Jamais ressenti une énergie aussi douce… les dauphins m'accompagnent partout", time: "14:08" },
  { name: "Thomas", text: "Mon premier soin sur ma fille a fonctionné, je n'en reviens pas", time: "18:21" },
  { name: "Sophie", text: "J'ai pleuré de joie pendant la méditation du dauphin rose", time: "07:55" },
  { name: "Marc", text: "La « dolphin banane » a changé mon quotidien au travail !", time: "11:34" },
  { name: "Laurence", text: "Je me sens enfin à ma place. Gratitude infinie.", time: "20:47" },
  { name: "Nadia", text: "Les guidances de l'oracle sont d'une justesse incroyable", time: "16:12" },
  { name: "Pierre", text: "Sceptique au début… aujourd'hui je fais des soins à mes proches", time: "22:03" },
  { name: "Valérie", text: "Le module 10 m'a reconnectée à ma mission d'âme", time: "08:29" },
  { name: "Céline", text: "Communauté bienveillante, lives inspirants, je recommande à 200%", time: "13:50" },
  { name: "Julien", text: "Chaque fréquence est un cadeau. Le module 14 m'a bouleversé.", time: "19:16" },
  { name: "Aurore", text: "Plus légère, plus joyeuse, plus alignée. Une vraie renaissance.", time: "10:07" },
];

// Interleave messages + real screenshots into two rows.
const imgs = SCREENSHOTS;
export const WALL_ROW_1 = [
  { type: "msg", ...WALL_MESSAGES[0] },
  { type: "img", src: imgs[4] },
  { type: "msg", ...WALL_MESSAGES[1] },
  { type: "msg", ...WALL_MESSAGES[2] },
  { type: "img", src: imgs[0] },
  { type: "msg", ...WALL_MESSAGES[3] },
  { type: "msg", ...WALL_MESSAGES[4] },
  { type: "img", src: imgs[5] },
  { type: "msg", ...WALL_MESSAGES[5] },
];
export const WALL_ROW_2 = [
  { type: "msg", ...WALL_MESSAGES[6] },
  { type: "img", src: imgs[1] },
  { type: "msg", ...WALL_MESSAGES[7] },
  { type: "msg", ...WALL_MESSAGES[8] },
  { type: "img", src: imgs[3] },
  { type: "msg", ...WALL_MESSAGES[9] },
  { type: "msg", ...WALL_MESSAGES[10] },
  { type: "img", src: imgs[2] },
  { type: "msg", ...WALL_MESSAGES[11] },
];
